import { IconProps } from '.';

export const CommunityIcon = ({ className, color = 'black', onClick }: IconProps) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='9' cy='4.5' r='3.75' stroke='black' strokeWidth='1.5' />
      <path
        d='M14.2495 1.5C16.3206 1.5 17.9995 3.17893 17.9995 5.25C17.9995 7.32107 16.3206 9 14.2495 9C13.2938 8.99988 12.4224 8.6414 11.7603 8.05273C12.1574 7.74377 12.5001 7.36942 12.7749 6.94629C13.1699 7.2901 13.6847 7.49988 14.2495 7.5C15.4922 7.5 16.4995 6.49264 16.4995 5.25C16.4995 4.00736 15.4922 3 14.2495 3C13.9139 3.00007 13.5961 3.07519 13.3101 3.20703C13.1636 2.71798 12.9369 2.2639 12.644 1.86035C13.1307 1.62937 13.675 1.50007 14.2495 1.5Z'
        fill={color}
      />
      <path
        d='M3.75 1.5C4.32452 1.5 4.86877 1.62942 5.35547 1.86035C5.06264 2.26396 4.83495 2.71792 4.68848 3.20703C4.40258 3.07548 4.08534 3 3.75 3C2.50736 3 1.5 4.00736 1.5 5.25C1.5 6.49264 2.50736 7.5 3.75 7.5C4.31458 7.5 4.8286 7.28976 5.22363 6.94629C5.4984 7.36959 5.84208 7.74365 6.23926 8.05273C5.57699 8.64136 4.70574 9 3.75 9C1.67893 9 0 7.32107 0 5.25C0 3.17893 1.67893 1.5 3.75 1.5Z'
        fill={color}
      />
      <path
        d='M9 8.25C11.0196 8.25 12.1611 8.81448 12.8613 9.65137C13.5952 10.5287 13.9619 11.8389 14.125 13.5732C14.3102 15.5431 12.6117 17.25 10.501 17.25H7.49902C5.38831 17.25 3.68979 15.5431 3.875 13.5732C4.03815 11.8389 4.40475 10.5287 5.13867 9.65137C5.83886 8.81448 6.98036 8.25 9 8.25Z'
        stroke={color}
        strokeWidth='1.5'
      />
      <path
        d='M3.75 7.5C4.48634 7.5 5.17258 7.75537 5.75195 8.19531C5.26542 8.46291 4.86486 8.80248 4.53516 9.20508C4.27345 9.0699 4.00365 9 3.75 9C2.75182 9 1.5 10.0755 1.5 12C1.5 13.6138 2.38112 14.6278 3.25391 14.9141C3.41705 15.4972 3.71366 16.0277 4.1084 16.4785C3.9904 16.4919 3.87093 16.5 3.75 16.5C1.67893 16.5 0 14.4853 0 12C0 9.51472 1.67893 7.5 3.75 7.5Z'
        fill={color}
      />
      <path
        d='M14.2502 7.5C16.3212 7.50016 18.0002 9.51482 18.0002 12C18.0002 14.4852 16.3212 16.4998 14.2502 16.5C14.1291 16.5 14.0091 16.492 13.8909 16.4785C14.2857 16.0277 14.5822 15.4973 14.7454 14.9141C15.6184 14.6281 16.5002 13.6142 16.5002 12C16.5002 10.0756 15.2484 9.00018 14.2502 9C13.9964 9 13.726 9.0697 13.4641 9.20508C13.1344 8.80259 12.7338 8.46382 12.2473 8.19629C12.8269 7.75591 13.5135 7.5 14.2502 7.5Z'
        fill={color}
      />
    </svg>
  );
};
